import { useCallback } from "react";
import { proxy, useSnapshot } from "valtio";
import { usePreviewContext } from "../contexts/preview-context";
import { useEditor } from "./useEditor";

const previewModeState = proxy({
	isPreviewMode: false,
});

export function useIsPreviewMode() {
	const { selection } = useEditor();
	const { resetZoom } = usePreviewContext();

	return [
		useSnapshot(previewModeState).isPreviewMode,
		useCallback(
			function setIsPreviewMode(value: boolean) {
				previewModeState.isPreviewMode = value;

				// Deselect the current zone when going to preview mode
				if (value) {
					selection.setCurrentZoneAndBroadcast(undefined);
				}

				// Reset zoom when changing preview mode (CRE-1747)
				resetZoom(selection.getCurrentSpread());
			},
			[selection, resetZoom],
		),
	] as const;
}
